import { render } from "./book-detail.vue?vue&type=template&id=1b61b663&scoped=true"
import script from "./book-detail.vue?vue&type=script&lang=js"
export * from "./book-detail.vue?vue&type=script&lang=js"

import "./book-detail.vue?vue&type=style&index=0&id=1b61b663&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\ahuview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b61b663"]])

export default __exports__